(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pb-pdp-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const money = (cents) =>
      '$ ' + (Math.round(cents) / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const init = (root) => {
      if (root.dataset.pbReady) return;
      root.dataset.pbReady = '1';

      const section = root.closest('[data-pb-pdp]') || document;
      const buy = root.closest('#pb-buy') || section;
      const pct = Number(root.dataset.pct) || 0;
      let variants = {};
      try {
        variants = JSON.parse(root.querySelector('[data-pb-offer-variants]').textContent);
      } catch (e) {}

      const radios = [...root.querySelectorAll('.pb-offer__radio')];
      const selects = [...root.querySelectorAll('[data-pb-offer-design]')];
      const addBtn = root.querySelector('[data-pb-offer-add]');
      const errorEl = root.querySelector('[data-pb-offer-error]');
      const stickyPrice = section.querySelector('[data-pb-sticky-price]');

      const form = () => buy.querySelector('product-form-component form, form[data-type="add-to-cart-form"]');
      const nativeAdd = () => buy.querySelector('button[name="add"]');
      const nativeVariant = () => {
        const checked = buy.querySelector('variant-picker input[type="radio"]:checked[data-variant-id]');
        const fromUrl = new URL(window.location.href).searchParams.get('variant');
        return checked?.dataset.variantId || fromUrl || form()?.querySelector('input[name="id"]')?.value;
      };

      const mode = () => (radios.find((r) => r.checked)?.value === '2' ? 2 : 1);

      const render = () => {
        const m = mode();
        section.classList.toggle('pb-offer-2', m === 2);
        root.querySelectorAll('[data-pb-offer-card]').forEach((c) => c.classList.toggle('is-active', c.dataset.pbOfferCard === String(m)));

        const v1 = variants[nativeVariant()] || Object.values(variants)[0];
        root.querySelector('[data-pb-offer-price="1"]').textContent = money(v1.price);
        root.querySelector('[data-pb-offer-compare="1"]').textContent = v1.compare > v1.price ? money(v1.compare) : '';

        const picks = selects.map((s) => variants[s.value]).filter(Boolean);
        const full = picks.reduce((a, v) => a + v.price, 0);
        const bundle = Math.round(full * (1 - pct / 100));
        root.querySelector('[data-pb-offer-price="2"]').textContent = money(bundle);
        root.querySelector('[data-pb-offer-compare="2"]').textContent = full > bundle ? money(full) : '';
        root.querySelector('[data-pb-offer-each]').textContent = (root.dataset.eachText || 'Elige 2 diseños') + ' · ' + money(bundle / 2) + ' c/u';

        if (stickyPrice) stickyPrice.textContent = m === 2 ? money(bundle) : money(v1.price);
      };

      const showError = (msg) => {
        errorEl.textContent = msg;
        errorEl.hidden = !msg;
      };

      addBtn.addEventListener('click', async () => {
        showError('');
        const [a, b] = selects.map((s) => s.value);
        const f = form();
        const idInput = f?.querySelector('input[name="id"]');
        const qtyInput = f?.querySelector('input[name="quantity"]');
        const btn = nativeAdd();
        if (!f || !idInput || !btn) return;

        addBtn.disabled = true;
        const prevId = idInput.value;
        const prevQty = qtyInput?.value;
        try {
          if (a !== b) {
            // El primer diseño se agrega directo; el segundo pasa por el formulario nativo
            // para que Horizon actualice el carrito y lo abra como siempre.
            const res = await fetch(window.Shopify?.routes?.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(a), quantity: 1 }] }),
            });
            if (!res.ok) throw new Error((await res.json()).description || 'No se pudo agregar');
            idInput.value = b;
            if (qtyInput) qtyInput.value = 1;
          } else {
            idInput.value = a;
            if (qtyInput) qtyInput.value = 2;
          }
          btn.click();
        } catch (err) {
          showError(err.message || 'No se pudo agregar al carrito. Intenta de nuevo.');
        } finally {
          setTimeout(() => {
            idInput.value = prevId;
            if (qtyInput && prevQty != null) qtyInput.value = prevQty;
            addBtn.disabled = false;
          }, 600);
        }
      });

      radios.forEach((r) => r.addEventListener('change', render));
      selects.forEach((s) => s.addEventListener('change', render));
      buy.addEventListener('change', (e) => {
        if (e.target.closest('variant-picker')) setTimeout(render, 450);
      });

      const def = root.dataset.default === '1' ? '1' : '2';
      (radios.find((r) => r.value === def) || radios[0]).checked = true;
      render();
    };

    const run = () => document.querySelectorAll('[data-pb-offer]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pb-pdp-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = () => (window.Shopify?.routes?.root || '/');

    const init = (box) => {
      if (box.dataset.pbReady) return;
      box.dataset.pbReady = '1';

      const section = box.closest('[data-pb-pdp]') || document;
      const buy = box.closest('#pb-buy') || section;
      const mainProductId = Number(box.dataset.mainProduct);
      const img = box.querySelector('[data-pb-upsell-img]');
      const compare = box.querySelector('[data-pb-upsell-compare]');
      const sale = box.querySelector('[data-pb-upsell-sale]');
      const addBtn = box.querySelector('[data-pb-upsell-add]');
      const status = box.querySelector('[data-pb-upsell-status]');
      const label = addBtn.textContent;

      const code = (box.dataset.code || '').trim();
      const picked = () => box.querySelector('input[type="radio"]:checked') || box.querySelector('input[type="radio"]');

      // Aplica el código del complemento sin quitar los que el cliente ya tenga.
      const applyCode = async (cart) => {
        if (!code) return;
        const current = (cart.discount_codes || []).map((d) => d.code);
        if (current.some((c) => c.toUpperCase() === code.toUpperCase())) return;
        await fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: [...current, code].join(',') }),
        });
      };

      box.addEventListener('change', (e) => {
        const r = e.target.closest('input[type="radio"]');
        if (!r) return;
        if (img && r.dataset.img) img.src = r.dataset.img;
        if (compare) compare.textContent = r.dataset.price;
        if (sale) sale.textContent = r.dataset.sale;
        const save = box.querySelector('[data-pb-upsell-save]');
        if (save) save.textContent = r.dataset.save;
      });

      const form = () => buy.querySelector('product-form-component form, form[data-type="add-to-cart-form"]');
      const nativeAdd = () => buy.querySelector('button[name="add"]');
      const mainCta = () => {
        const offer = buy.querySelector('[data-pb-offer-add]');
        if (offer && section.classList.contains('pb-offer-2')) return offer;
        return nativeAdd();
      };

      const say = (msg) => {
        status.textContent = msg;
      };

      addBtn.addEventListener('click', async () => {
        const r = picked();
        if (!r) return;
        const id = Number(r.value);
        addBtn.disabled = true;
        say('');
        try {
          const cart = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json());
          const hasMain = cart.items.some((i) => i.product_id === mainProductId);
          await applyCode(cart);

          if (!hasMain) {
            // Sin tapete en el carrito: se agrega el complemento y después el tapete con el botón
            // principal, para que Horizon actualice y abra el carrito como siempre.
            const res = await fetch(root() + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
            });
            if (!res.ok) throw new Error((await res.json()).description || 'No se pudo agregar');
            mainCta()?.click();
          } else {
            // El tapete ya está en el carrito: solo se agrega el complemento por el formulario nativo.
            const f = form();
            const idInput = f?.querySelector('input[name="id"]');
            const qtyInput = f?.querySelector('input[name="quantity"]');
            const btn = nativeAdd();
            if (!f || !idInput || !btn) throw new Error('No se pudo agregar');
            const prevId = idInput.value;
            const prevQty = qtyInput?.value;
            idInput.value = id;
            if (qtyInput) qtyInput.value = 1;
            btn.click();
            setTimeout(() => {
              idInput.value = prevId;
              if (qtyInput && prevQty != null) qtyInput.value = prevQty;
            }, 600);
          }
          addBtn.textContent = 'Agregado ✓';
          say(r.dataset.label + ' agregado a tu carrito.');
          setTimeout(() => {
            addBtn.textContent = label;
          }, 3000);
        } catch (err) {
          say(err.message || 'No se pudo agregar. Intenta de nuevo.');
        } finally {
          setTimeout(() => {
            addBtn.disabled = false;
          }, 800);
        }
      });
    };

    const run = () => document.querySelectorAll('[data-pb-upsell]').forEach(init);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  })();
  } catch(e) { console.error(e); }
})();

})();
